<template>
  <router-view />
</template>

<script>
  export default {
    name: "CooperativeManagement",
  };
</script>
